import { PropsWithChildren } from 'react'
import { authService } from '@oneblink/apps-react'
import { AuthContextProvider } from '@oneblink/apps-react'
import Login from './Login'

export default function AuthenticatedForm({
  children,
  formHasAuthentication,
}: PropsWithChildren<{ formHasAuthentication: boolean }>) {
  if (!formHasAuthentication) {
    return <>{children}</>
  }
  const isLoggedIn = authService.isLoggedIn()

  // we should never get here but just in case
  if (!isLoggedIn) {
    return <Login />
  }

  return <AuthContextProvider>{children}</AuthContextProvider>
}
